import * as yup from "yup";

const createReplacementOrderSchema = (metadataFields = {}, projectDocuments = []) => {

  return yup.object().shape({
    // Always required fields
    dataMap: yup.string().required().label("Data Map"),
    replacementReason: yup
      .string()
      .required("Replacement Reason is required")
      .label("Replacement Reason"),
    projectCode: yup.string().required().label("Project Code"),
    company: yup.string().required().label("Company"),

    // Conditionally mandatory fields based on metadataFields config
    agency: metadataFields?.agency?.mandatory
      ? yup.string().required().label("Agency")
      : yup.string().label("Agency"),
    commodity: metadataFields?.commodity?.mandatory
      ? yup
          .string()
          .required()
          .matches(/^(?!\s+$).+/, "Please provide valid values for commodity")
          .label("Commodity")
      : yup.string().label("Commodity"),
    sampleVariant: metadataFields?.variant?.mandatory
      ? yup.string().required().label("Sample Variant")
      : yup.string().label("Sample Variant"),
    sampleType: metadataFields?.sampleType?.mandatory
      ? yup.string().required().label("Sample Type")
      : yup.string().label("Sample Type"),
    sector: metadataFields?.sector?.mandatory
      ? yup.string().required().label("Sector")
      : yup.string().label("Sector"),
    state: metadataFields?.state?.mandatory
      ? yup.string().required().label("State")
      : yup.string().label("State"),
    district: metadataFields?.district?.mandatory
      ? yup.string().required().label("District")
      : yup.string().label("District"),
    destinationCountry: metadataFields?.destinationCountry?.mandatory
      ? yup.string().required().label("Destination Country")
      : yup.string().label("Destination Country"),
    samplingType: metadataFields?.samplingType?.mandatory
      ? yup.string().required().label("Sampling Type")
      : yup.string().label("Sampling Type"),
    codewiseReason: yup
      .string()
      .label("Code-wise Reason")
      .when("samplingType", {
        is: "Code-wise Sampling",
        then: (schema) =>
          metadataFields?.codewiseReason?.mandatory
            ? schema.required("Code-wise Reason is required")
            : schema,
        otherwise: (schema) => schema.notRequired(),
      }),
    expectedConsignmentReadiness: metadataFields?.expectedConsignmentReadiness
      ?.mandatory
      ? yup.string().required().label("Expected Consignment Readiness")
      : yup.string().label("Expected Consignment Readiness"),
    expectedShipmentDate: metadataFields?.expectedShipmentDate?.mandatory
      ? yup.string().required().label("Expected Shipment Date")
      : yup.string().label("Expected Shipment Date"),
    sampler: metadataFields?.sampler?.mandatory
      ? yup.string().required().label("Sampler")
      : yup.string().label("Sampler"),
    siteAddress: metadataFields?.siteAddress?.mandatory
      ? yup.string().required().label("Site Address")
      : yup.string().label("Site Address"),
    package: yup.string().required().label("Package"),
    batchId: metadataFields?.batchId?.mandatory
      ? yup.string().required().label("Batch ID")
      : yup.string().label("Batch ID"),
    supplier: metadataFields?.supplier?.mandatory
      ? yup.string().required().label("Supplier")
      : yup.string().label("Supplier"),
    quantity: metadataFields?.quantity?.mandatory
      ? yup.string().required().label("Quantity")
      : yup.string().label("Quantity"),
    quantityUnit: metadataFields?.quantityUnit?.mandatory
      ? yup.string().required().label("Quantity Unit")
      : yup.string().label("Quantity Unit"),
    additionalNotes: metadataFields?.notes?.mandatory
      ? yup.string().required().label("Additional Notes")
      : yup.string().label("Additional Notes"),

    // Document validation
    documents: yup
      .array()
      .test("required-documents", "", (value) => {
        const requiredDocsList = projectDocuments.filter((doc) => doc.required);
        const requiredDocIdsList = requiredDocsList.map((doc) => doc._id);

        const uploadedDocIds = Array.isArray(value)
          ? value.map((doc) => doc._id)
          : [];

        const missingDocIds = requiredDocIdsList.filter(
          (docId) => !uploadedDocIds.includes(docId)
        );

        if (missingDocIds.length > 0) {
          const missingNames = requiredDocsList
            .filter((doc) => missingDocIds.includes(doc._id))
            .map((doc) => doc.documentName);
          return new yup.ValidationError(
            `Please upload: ${missingNames.join(", ")}`,
            value,
            "documents"
          );
        }
        return true;
      })
      .label("Documents"),
  });
};

export default createReplacementOrderSchema;
